<mat-toolbar class="versao" color="primary">
    <footer>
        <a color="primary" class="linkFlex" href="https://flexsmart.com.br/" target="_blank">Desenvolvido por: Flex
            Smart - {{versao}}</a>
    </footer>
</mat-toolbar>